'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Tree", {
    enumerable: true,
    get: function() {
        return Tree;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTree = require("./useTree");
const _useTreeContextValues = require("./useTreeContextValues");
const _useTreeStylesstyles = require("./useTreeStyles.styles");
const _renderTree = require("./renderTree");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const Tree = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTree.useTree_unstable)(props, ref);
    const contextValues = (0, _useTreeContextValues.useTreeContextValues_unstable)(state);
    (0, _useTreeStylesstyles.useTreeStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTreeStyles_unstable')(state);
    return (0, _renderTree.renderTree_unstable)(state, contextValues);
});
Tree.displayName = 'Tree';
